import { SubscriberDataEvent } from 'util/analytics';
import { ReactComponent as CheckYetiIcon } from 'public/assets/resort/partner_checkYetiIcon2.svg';
import { ReactComponent as AlpineResorts } from 'public/assets/resort/partner_alpineresorts.svg';

export const patnerTypes = {
  lessons: {
    icon: <CheckYetiIcon height={143} width={143} />,
    header: 'tripWidget.schoolBooking',
    analiticType: SubscriberDataEvent.LessonsWidget,
    benefits: ['tripWidget.checkYetiBenefits1', 'tripWidget.checkYetiBenefits2', 'tripWidget.checkYetiBenefits3'],
  },
  rental: {
    icon: <AlpineResorts height={143} width={143} />,
    header: 'tripWidget.skiRentalLabel',
    analiticType: SubscriberDataEvent.RentalsWidget,
    benefits: ['tripWidget.skiRentalBenefits1', 'tripWidget.skiRentalBenefits2', 'tripWidget.skiRentalBenefits3'],
  },
};
